// extracted by mini-css-extract-plugin
module.exports = {"header":"salesChannelCountByInventoryItem_header__1X2ut","heading":"salesChannelCountByInventoryItem_heading__cbRyF","image":"salesChannelCountByInventoryItem_image__3V2pq"};